import CircularLoader from "@/components/loading/LoadingComponent";
import { AuthContext } from "@/contexts/AuthContext";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface GuardProps {
    children: React.ReactNode;
}

const SuperuserGuard = ({ children }: GuardProps) => {
    const { user, loading } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && user && !user.isSuperuser) {
            navigate("/dashboard");
        }
    }, [user, loading, navigate]);

    if (loading) {
        return <CircularLoader />;
    }

    return <>{children}</>;
};

export default SuperuserGuard;
